<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="110">
          <template slot-scope="{row}">
            <el-button type="text" @click="detail(row)">查看</el-button>
            <template v-if="$permission.canWrite()">
              <el-button type="text" @click="editById(row.ArticleId)">编辑</el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <check-dialog ref="checkDialog" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/infoRelease/notice/list";
import editDialog from "@/components/infoRelease/notice/editDialog";
import checkDialog from "@/components/infoRelease/notice/checkDialog";

export default {
  name: "notice",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    checkDialog,
  },
  computed: {},
  mounted() {},
  methods: {
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.ArticleId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    detail(row) {
      this.$refs.checkDialog.openDetails(row);
    },
  },
};
</script>